module.exports = __webpack_public_path__ + "img/DJI_0086_full.bb8faac8.jpg";